import React from 'react'
import styled from 'styled-components'
import { colors, Button } from '@giphy/react-giphy-brand'

const Apple = styled(Button)`
    background: ${colors.giphyDarkestGrey};
    border-radius: 3px;
    font-size: 15px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const AppleIcon = styled.img`
    height: 20px;
`

const ButtonText = styled.div`
    padding-left: 10px;
`

type Props = {
    className?: string
    onClick?: () => void
    label?: string
}

const AppleButton = ({
    className,
    onClick = () => (location.href = `/login/apple/${location.search}`),
    label = 'Login with Apple',
}: Props) => (
    <Apple className={className} onClick={onClick} type="button">
        <AppleIcon src="/static/img/svg/apple-logo.svg" alt="Apple login icon" />
        <ButtonText>{label}</ButtonText>
    </Apple>
)

export default AppleButton
